import axios from 'axios'
import Vue from 'vue'
import {ERROR, SUCCESS} from '../ui/UI'
import {DOCS_EXPORT_ORIGINAL} from '../../../models/documents/export-types'
import {SETTINGS_EXPORTS} from '../../../views/settings/settings-tabs'
import {DEVELOPER_PIPELINE_RETURN} from '../../../models/documents/developer'
import {UNASSIGNED} from '@/types/data'

export const BULK_DOCS_SET = 'BULK_DOCS_SET'
export const BULK_DOCS_ADD = 'BULK_DOCS_ADD'
export const BULK_DOCS_REMOVE = 'BULK_DOCS_REMOVE'

export const BULK_DOCS_ASSIGN = 'BULK_DOCS_ASSIGN'
export const BULK_DOCS_EMAIL = 'BULK_DOCS_EMAIL'
export const BULK_DOCS_STATUS_UPDATE = 'BULK_DOCS_STATUS_UPDATE'
export const BULK_DOCS_LOCATION_UPDATE = 'BULK_DOCS_LOCATION_UPDATE'
export const BULK_DOCS_DATE_DUE_UPDATE = 'BULK_DOCS_DATE_DUE_UPDATE'
export const BULK_DOCS_DELETE = 'BULK_DOCS_DELETE'
export const BULK_DOCS_APPROVE = 'BULK_DOCS_APPROVE'
export const BULK_DOCS_REMIND = 'BULK_DOCS_REMIND'
export const BULK_DOCS_EXPORT = 'BULK_DOCS_EXPORT'
export const BULK_DOCS_MERGE = 'BULK_DOCS_MERGE'
export const BULK_DOCS_REJECT = 'BULK_DOCS_REJECT'
export const BULK_DOCS_DEVELOPER = 'BULK_DOCS_DEVELOPER'

export const BULK_DOCS_SET_IS_ASSIGNING = 'BULK_DOCS_SET_IS_ASSIGNING'
export const BULK_DOCS_SET_IS_EMAILING = 'BULK_DOCS_SET_IS_EMAILING'
export const BULK_DOCS_SET_IS_STATUS_UPDATING = 'BULK_DOCS_SET_IS_STATUS_UPDATING'
export const BULK_DOCS_SET_IS_LOCATION_UPDATING = 'BULK_DOCS_SET_IS_LOCATION_UPDATING'
export const BULK_DOCS_SET_IS_DATE_DUE_UPDATING = 'BULK_DOCS_SET_IS_DATE_DUE_UPDATING'
export const BULK_DOCS_SET_IS_DELETING = 'BULK_DOCS_SET_IS_DELETING'
export const BULK_DOCS_SET_IS_APPROVING = 'BULK_DOCS_SET_IS_APPROVING'
export const BULK_DOCS_SET_IS_REMINDING = 'BULK_DOCS_SET_IS_REMINDING'
export const BULK_DOCS_SET_IS_EXPORTING = 'BULK_DOCS_SET_IS_EXPORTING'
export const BULK_DOCS_SET_IS_MERGING = 'BULK_DOCS_SET_IS_MERGING'
export const BULK_DOCS_SET_IS_REJECTING = 'BULK_DOCS_SET_IS_REJECTING'
export const BULK_DOCS_SET_IS_RUNNING_DEV = 'BULK_DOCS_SET_IS_RUNNING_DEV'

const state = {
    bulkDocs: [],

    isBulkAssigning: false,
    isBulkEmailing: false,
    isBulkStatusUpdating: false,
    isBulkLocationUpdating: false,
    isBulkDateDueUpdating: false,
    isBulkDeleting: false,
    isBulkApproving: false,
    isBulkReminding: false,
    isBulkExporting: false,
    isBulkMerging: false,
    isBulkRejecting: false,
    isDevActionRunning: false
}

const getters = {
    bulkDocs: state => state.bulkDocs,
    bulkDocsIds: state => state.bulkDocs.map(doc => doc.uuid),
    checkIsBulkDoc: state => uuid => state.bulkDocs.findIndex(el => el.uuid === uuid) !== -1,

    isBulkAssigning: state => state.isBulkAssigning,
    isBulkEmailing: state => state.isBulkEmailing,
    isBulkStatusUpdating: state => state.isBulkStatusUpdating,
    isBulkLocationUpdating: state => state.isBulkLocationUpdating,
    isBulkDateDueUpdating: state => state.isBulkDateDueUpdating,
    isBulkDeleting: state => state.isBulkDeleting,
    isBulkApproving: state => state.isBulkApproving,
    isBulkReminding: state => state.isBulkReminding,
    isBulkExporting: state => state.isBulkExporting,
    isBulkMerging: state => state.isBulkMerging,
    isBulkRejecting: state => state.isBulkRejecting,
    isDevActionRunning: state => state.isDevActionRunning,

    getBulkDocsUser: (state, getters, rootState, rootGetters) => {
        if (state.bulkDocs[0] &&
            state.bulkDocs[0].user &&
            state.bulkDocs.every(doc => doc.user && doc.user === state.bulkDocs[0].user) &&
            rootGetters.getMemberByUuid(state.bulkDocs[0].user)) {
            return rootGetters.getMemberByUuid(state.bulkDocs[0].user)
        }
        return {} // different users
    },

    getBulkDocsStatus: (state, getters, rootState, rootGetters) => {
        if (state.bulkDocs[0] &&
            state.bulkDocs[0].status &&
            state.bulkDocs.every(doc => doc.status === state.bulkDocs[0].status ||
                (doc.status && doc.status.uuid === state.bulkDocs[0].status.uuid))) {
            return rootGetters['documents/getDocumentStatusModel'](state.bulkDocs[0])
        }
        return {name: 'Unknown', color: 'grey'} // different statuses
    },

    getBulkDocsLocation: (state, getters, rootState, rootGetters) => {
        if (state.bulkDocs[0] &&
            state.bulkDocs[0].location &&
            state.bulkDocs.every(doc => doc.location === state.bulkDocs[0].location)) {
            return rootGetters.getLocationByUuid(state.bulkDocs[0].location)
        }
        return {} // different location
    },

    getBulkDocsDateDue: (state) => {
        if (state.bulkDocs[0] &&
            state.bulkDocs[0].dateDue &&
            state.bulkDocs.every(doc => doc.dateDue === state.bulkDocs[0].dateDue)) {
            return state.bulkDocs[0].dateDue
        }
        return null // different dates or not selected
    }
}

const mutations = {
    [BULK_DOCS_SET]: (state, data) => {
        state.bulkDocs = data || []
    },
    [BULK_DOCS_ADD]: (state, doc) => {
        if (!doc || !doc.uuid) {
            return
        }
        state.bulkDocs.push(doc)
    },
    [BULK_DOCS_REMOVE]: (state, doc) => {
        const idx = state.bulkDocs.findIndex(el => doc && el.uuid === doc.uuid)
        if (idx !== -1) {
            state.bulkDocs.splice(idx, 1)
        }
    },

    [BULK_DOCS_SET_IS_ASSIGNING]: (state, flag) => {
        state.isBulkAssigning = flag
    },
    [BULK_DOCS_SET_IS_STATUS_UPDATING]: (state, flag) => {
        state.isBulkStatusUpdating = flag
    },
    [BULK_DOCS_SET_IS_LOCATION_UPDATING]: (state, flag) => {
        state.isBulkLocationUpdating = flag
    },
    [BULK_DOCS_SET_IS_DATE_DUE_UPDATING]: (state, flag) => {
        state.isBulkDateDueUpdating = flag
    },
    [BULK_DOCS_SET_IS_DELETING]: (state, flag) => {
        state.isBulkDeleting = flag
    },
    [BULK_DOCS_SET_IS_APPROVING]: (state, flag) => {
        state.isBulkApproving = flag
    },
    [BULK_DOCS_SET_IS_REMINDING]: (state, flag) => {
        state.isBulkReminding = flag
    },
    [BULK_DOCS_SET_IS_EXPORTING]: (state, flag) => {
        state.isBulkExporting = flag
    },
    [BULK_DOCS_SET_IS_RUNNING_DEV]: (state, flag) => {
        state.isDevActionRunning = flag
    },
    [BULK_DOCS_SET_IS_MERGING]: (state, flag) => {
        state.isBulkMerging = flag
    },
    [BULK_DOCS_SET_IS_REJECTING]: (state, flag) => {
        state.isBulkRejecting = flag
    },
    [BULK_DOCS_SET_IS_EMAILING]: (state, flag) => {
        state.isBulkEmailing = flag
    }
}

const actions = {
    [BULK_DOCS_ASSIGN]({commit, getters}, user) {
        if (!user || !user.uuid) {
            return
        }
        if (user.uuid === UNASSIGNED) {
            user = UNASSIGNED
        }
        commit(BULK_DOCS_SET_IS_ASSIGNING, true)
        return axios.post('bulk/assign', {transactions: getters.bulkDocsIds, user})
            .then(() => {
                const docs = getters.bulkDocs
                docs.forEach(doc => {
                    doc.user = user.uuid
                })
                commit(BULK_DOCS_SET, docs)
            })
            .catch(() => {
                Vue.prototype.$snackbar.show({type: ERROR})
            })
            .finally(() => {
                commit(BULK_DOCS_SET_IS_ASSIGNING, false)
            })
    },

    [BULK_DOCS_EMAIL]({commit, getters}, payload) {
        commit(BULK_DOCS_SET_IS_EMAILING, true)
        return axios.post('bulk/email', {transactions: getters.bulkDocsIds, ...payload})
            .finally(() => {
                commit(BULK_DOCS_SET_IS_EMAILING, false)
            })
    },

    [BULK_DOCS_STATUS_UPDATE]({commit, getters}, status) {
        if (!status || !status.key) {
            return
        }
        commit(BULK_DOCS_SET_IS_STATUS_UPDATING, true)
        return axios.post('bulk/status', {transactions: getters.bulkDocsIds, status})
            .then(() => {
                const docs = getters.bulkDocs
                docs.forEach(doc => {
                    doc.status = status.key
                })
                commit(BULK_DOCS_SET, docs)
            })
            .catch(() => {
                Vue.prototype.$snackbar.show({type: ERROR})
            })
            .finally(() => {
                commit(BULK_DOCS_SET_IS_STATUS_UPDATING, false)
            })
    },

    [BULK_DOCS_LOCATION_UPDATE]({commit, getters}, location) {
        if (!location || !location.uuid) {
            return
        }
        commit(BULK_DOCS_SET_IS_LOCATION_UPDATING, true)
        return axios.post('bulk/location', {transactions: getters.bulkDocsIds, location})
            .then(() => {
                const docs = getters.bulkDocs
                docs.forEach(doc => {
                    doc.location = location.uuid
                })
                commit(BULK_DOCS_SET, docs)
            })
            .catch(() => {
                Vue.prototype.$snackbar.show({type: ERROR})
            })
            .finally(() => {
                commit(BULK_DOCS_SET_IS_LOCATION_UPDATING, false)
            })
    },

    [BULK_DOCS_DATE_DUE_UPDATE]({commit, getters}, dateDue) {
        if (!dateDue) {
            return
        }
        commit(BULK_DOCS_SET_IS_DATE_DUE_UPDATING, true)
        return axios.post('bulk/dates', {transactions: getters.bulkDocsIds, dateDue})
            .then(() => {
                const docs = getters.bulkDocs
                docs.forEach(doc => {
                    doc.dateDue = dateDue
                })
                commit(BULK_DOCS_SET, docs)
            })
            .catch(() => {
                Vue.prototype.$snackbar.show({type: ERROR})
            })
            .finally(() => {
                commit(BULK_DOCS_SET_IS_DATE_DUE_UPDATING, false)
            })
    },

    [BULK_DOCS_DELETE]({commit, getters}) {
        commit(BULK_DOCS_SET_IS_DELETING, true)
        return axios.post('bulk/delete', {transactions: getters.bulkDocsIds})
            .then(() => {
                commit(BULK_DOCS_SET, [])
            })
            .catch(() => {
                Vue.prototype.$snackbar.show({type: ERROR})
            })
            .finally(() => {
                commit(BULK_DOCS_SET_IS_DELETING, false)
            })
    },

    [BULK_DOCS_MERGE]({commit, getters}) {
        commit(BULK_DOCS_SET_IS_MERGING, true)
        return axios.post('bulk/merge', {transactions: getters.bulkDocsIds})
            .then(() => {
                commit(BULK_DOCS_SET, [])
                Vue.prototype.$snackbar.show({type: SUCCESS})
            })
            .catch(() => {
                Vue.prototype.$snackbar.show({type: ERROR})
            })
            .finally(() => {
                commit(BULK_DOCS_SET_IS_MERGING, false)
            })
    },

    [BULK_DOCS_APPROVE]({commit, getters}) {
        commit(BULK_DOCS_SET_IS_APPROVING, true)
        return axios.post('bulk/approve', {transactions: getters.bulkDocsIds})
            .then(() => {
                commit(BULK_DOCS_SET, [])
            })
            .catch(() => {
                Vue.prototype.$snackbar.show({type: ERROR})
            })
            .finally(() => {
                commit(BULK_DOCS_SET_IS_APPROVING, false)
            })
    },

    [BULK_DOCS_REMIND]({commit, getters}) {
        commit(BULK_DOCS_SET_IS_REMINDING, true)
        return axios.post('bulk/remind', {transactions: getters.bulkDocsIds})
            .then(() => {
                commit(BULK_DOCS_SET, [])
            })
            .catch(() => {
                Vue.prototype.$snackbar.show({type: ERROR})
            })
            .finally(() => {
                commit(BULK_DOCS_SET_IS_REMINDING, false)
            })
    },

    [BULK_DOCS_REJECT]({commit, getters}, reject) {
        commit(BULK_DOCS_SET_IS_REJECTING, true)
        return axios.post('bulk/reject', {reject: {respond: false}, transactions: getters.bulkDocsIds})
            .then(() => {
                commit(BULK_DOCS_SET, [])
            })
            .finally(() => {
                commit(BULK_DOCS_SET_IS_REJECTING, false)
            })
    },

    [BULK_DOCS_EXPORT]({commit, getters, rootGetters}, type = DOCS_EXPORT_ORIGINAL) {
        commit(BULK_DOCS_SET_IS_EXPORTING, true)
        return axios.post('bulk/export', {transactions: getters.bulkDocsIds, type})
            .then(() => {
                Vue.prototype.$snackbar.show({
                    type: SUCCESS,
                    text: 'Export started',
                    caption: `<a href="${location.origin}/app/${rootGetters.activeTeamId}/settings/${SETTINGS_EXPORTS}">View</a>`
                })
            })
            .catch(() => {
                Vue.prototype.$snackbar.show({type: ERROR})
            })
            .finally(() => {
                commit(BULK_DOCS_SET_IS_EXPORTING, false)
            })
    },

    [BULK_DOCS_DEVELOPER]({commit, getters, rootGetters}, type = DEVELOPER_PIPELINE_RETURN) {
        commit(BULK_DOCS_SET_IS_RUNNING_DEV, true)
        return axios.post('bulk/developer', {transactions: getters.bulkDocsIds, type})
            .then(() => {
                commit(BULK_DOCS_SET, [])
            })
            .catch(() => {
                Vue.prototype.$snackbar.show({type: ERROR})
            })
            .finally(() => {
                commit(BULK_DOCS_SET_IS_RUNNING_DEV, false)
            })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
